import React, { Component } from 'react';
import { AddressForm } from './components/AddressForm';
import { ConfirmPrimaryCare } from './components/ConfirmPrimaryCare';
import { ReferringPhysician } from './components/ReferringPhysician';
import { OBGYNConfirmation } from './components/OBGYNConfirmation';
import { AgeWarningConfirmation } from './components/AgeWarningConfirmation';

export class AppointmentRequirementsView extends Component {
    renderChildIfOn(shouldShow, Child) {
        const { ...allProps } = this.props;

        if (shouldShow) {
            return <Child {...allProps} />;
        }
    }

    render() {
        const {
            requiresAddress,
            requiresReferral,
            requiresPrimaryCareConfirmation,
            requiresObgynConfirmation,
            requiresAgeWarningConfirmation,
        } = this.props;

        return (
            <React.Fragment>
                {this.renderChildIfOn(requiresAddress, AddressForm)}
                {this.renderChildIfOn(requiresReferral, ReferringPhysician)}
                {this.renderChildIfOn(
                    requiresPrimaryCareConfirmation,
                    ConfirmPrimaryCare
                )}
                {this.renderChildIfOn(
                    requiresObgynConfirmation,
                    OBGYNConfirmation
                )}
                {this.renderChildIfOn(
                    requiresAgeWarningConfirmation,
                    AgeWarningConfirmation
                )}
            </React.Fragment>
        );
    }
}
